__turbopack_context__.v({
  "title": "Performers-module-scss-module__hP4xCW__title",
  "toggleButton": "Performers-module-scss-module__hP4xCW__toggleButton",
});
